var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-production-status text-center alert p-1 mb-0",class:("alert-" + _vm.alertClass),domProps:{"innerHTML":_vm._s(_vm.$t(("OrderProductionStatus.status." + (_vm.order.status.production))))}})}
var staticRenderFns = []

export { render, staticRenderFns }